(function(){

 
const DEPTH=[
 {id:'position',label:'01 · Our Stories'},
 {id:'shop',label:'02 · Shop by style'},
 {id:'shelf',label:'03 · Colour stories'},
 {id:'colour',label:'04 · Colour story'},
 {id:'collections',label:'05 · Collections'},
 {id:'dot',label:'06 · The dot'},
 {id:'guide',label:'07 · Field guide'},
 {id:'press',label:'08 · In print'},
 {id:'journal',label:'09 · Dispatches'}
];
 
(function(){
  const FARMS=[
    {name:'Lake Hāwea Station',
     img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-lake-hawea-station-image-1.jpg'),imgAlt:'Lake Hāwea Station, Central Otago, New Zealand',sheep:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-lake-hawea-station-sheep-image.jpg'),
     blurb:'This is where the dot lands you. A high-country station in the Queenstown Lakes District, owned by Geoff and Justine Ross — who have mapped every plant on the property and built tools to measure the carbon their soil, pasture and tussock pull from the sky, pushing the boundaries of climate-positive farming.',
     meta:['Geoff & Justine Ross','Queenstown Lakes District'],
     coords:'44°35′S · 169°15′E',region:'Central Otago, NZ',
     owners:'Geoff & Justine Ross',scale:'High-country station · ZQ Merino',
     land:'Science-led regenerative high country — every plant mapped, soil carbon measured.',
     outcome:'Carbon-negative — soil, pasture and tussock measured to capture more CO₂ than the station emits.',
     temp:'4°C',sky:'Partly cloudy',wind:'Wind 3 km/h',map:{x:243,y:221,region:'Central Otago'}},
    {name:'Omarama Station',
     img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-omarama-station-image-1.jpg'),imgAlt:'Omarama Station, Mackenzie Country, New Zealand',sheep:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-omarama-station-sheep-image.jpg'),
     blurb:'This is where the dot lands you. 12,000 hectares of Mackenzie Country, farmed by the Subtil family for three generations. They monitor every waterway crossing the land — it leaves cleaner than it arrives — and run a longfin eel recovery programme, carrying mature females past the hydro dams to the coast to breed.',
     meta:['Richard & Annabelle Subtil','Three generations'],
     coords:'44°29′S · 169°58′E',region:'Mackenzie Country, NZ',
     owners:'Richard & Annabelle Subtil',scale:'12,000 hectares · Mackenzie',
     land:'Regenerative farming and ecosystem restoration across 12,000 ha of Mackenzie high country.',
     outcome:'Water leaves the land cleaner than it arrives; a longfin eel recovery programme runs each season.',
     temp:'6°C',sky:'Clear',wind:'Wind 8 km/h',map:{x:284,y:220,region:'Mackenzie'}},
    {name:'Middlehurst Station',
     img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-middlehurst-station-image-1.jpg'),imgAlt:'Middlehurst Station, Upper Awatere Valley, Marlborough',sheep:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-middlehurst-station-sheep-image.jpg'),
     blurb:"This is where the dot lands you. One of New Zealand's original high-country runs — 16,550 hectares in Marlborough's Upper Awatere Valley, held by Willie and Susan Macdonald, who pair generations of high-country stewardship with modern practice to grow consistently fine merino.",
     meta:['Willie & Susan Macdonald','Original high-country run'],
     coords:'42°08′S · 173°08′E',region:'Upper Awatere, Marlborough',
     owners:'Willie & Susan Macdonald',scale:'16,550 hectares · Marlborough',
     land:"One of NZ's original high-country runs — stewardship passed down, practices modernised.",
     outcome:'Long-term stewardship, modernised — for consistently high-quality natural fibre.',
     temp:'9°C',sky:'High cloud',wind:'Wind 14 km/h',map:{x:461,y:106,region:'Marlborough'}}
  ];
  const f=FARMS[Math.floor(Math.random()*FARMS.length)];
  const set=(id,txt)=>{const el=document.getElementById(id);if(el)el.textContent=txt;};
  set('stStatus','Connected · '+f.name+' · live');
  set('stTitle',f.name); set('stBlurb',f.blurb); set('stTag',f.name);
  set('stTemp',f.temp); set('stSky',f.sky); set('stWind',f.wind); set('stOutcome',f.outcome);
  const meta=document.getElementById('stMeta'); if(meta)meta.innerHTML='<span></span><span></span>',meta.children[0].textContent=f.meta[0],meta.children[1].textContent=f.meta[1];
  const img=document.getElementById('stImg'); if(img){img.src=f.img;img.alt=f.imgAlt;}
  const sheep=document.getElementById('stSheep'); if(sheep){if(f.sheep)sheep.src=f.sheep;sheep.alt='Merino at '+f.name;}
  const m=f.map||{};
  const ring=document.getElementById('stRing'); if(ring&&m.x!=null){ring.setAttribute('cx',m.x);ring.setAttribute('cy',m.y);}
  const pinDot=document.getElementById('stPinDot'); if(pinDot&&m.x!=null){pinDot.setAttribute('cx',m.x);pinDot.setAttribute('cy',m.y);}
  const region=document.getElementById('stRegion'); if(region&&m.region)region.textContent=m.region.toUpperCase();
  const s1=document.getElementById('stSpec1');
  if(s1){
    const row=(k,v)=>{const d=document.createElement('div');d.className='st-row';const s=document.createElement('span');s.textContent=k;const b=document.createElement('b');b.innerHTML=v;d.appendChild(s);d.appendChild(b);return d;};
    s1.innerHTML='';
    const t=document.createElement('div');t.className='st-spec-title';t.textContent=f.name;s1.appendChild(t);
    s1.appendChild(row('Location',f.coords+'<br>'+f.region));
    s1.appendChild(row('Owners',f.owners));
    s1.appendChild(row('Scale',f.scale));
    s1.appendChild(row('Land',f.land));
  }
})();

 
(function(){var t=document.getElementById('lh-time'),d=document.getElementById('lh-date');if(!t)return;function tick(){try{var n=new Date();t.textContent=n.toLocaleTimeString('en-NZ',{timeZone:'Pacific/Auckland',hour:'2-digit',minute:'2-digit',hour12:false});if(d)d.textContent=n.toLocaleDateString('en-NZ',{timeZone:'Pacific/Auckland',weekday:'short',day:'2-digit',month:'short'})+' · NZST';}catch(e){}}tick();setInterval(tick,30000);})();
const dInner=document.querySelector('.depth-inner'),dFill=document.getElementById('depthFill'),dDot=document.getElementById('depthDot'),dLabel=document.getElementById('depthLabel'),dTicks=document.getElementById('depthTicks');
let dSecs=[];
function depthBuild(){
  dTicks.innerHTML='';
  const docH=document.documentElement.scrollHeight,railH=dInner.clientHeight;
  dSecs=DEPTH.map(d=>{const el=document.getElementById(d.id);if(!el)return null;const top=el.getBoundingClientRect().top+window.scrollY;const tickPos=Math.min(railH,Math.max(0,(top/docH)*railH));const b=document.createElement('button');b.className='depth-tick';b.type='button';b.style.top=tickPos+'px';b.dataset.id=d.id;b.title=d.label;b.innerHTML=`<span class="dt-mark"></span><span class="dt-lab">${d.label}</span>`;dTicks.appendChild(b);return{...d,top,tickPos};}).filter(Boolean);
}
dTicks.addEventListener('click',e=>{const b=e.target.closest('.depth-tick');if(!b)return;const el=document.getElementById(b.dataset.id);if(!el)return;const y=el.getBoundingClientRect().top+window.scrollY-72;window.scrollTo({top:Math.max(0,y),behavior:'smooth'});});
const depthEl=document.getElementById('depth');
function depthBgAdapt(){
  const midY=window.innerHeight*0.5; let dark=false;
  [document.querySelector('.hero'),document.querySelector('.mood'),document.querySelector('footer')].forEach(el=>{
    if(!el)return; const r=el.getBoundingClientRect(); if(r.top<=midY && r.bottom>=midY) dark=true;
  });
  depthEl.classList.toggle('on-dark',dark);
}
 
let depthActive=false, depthIdleT=null, dragging=false;
function depthPoke(){
  depthActive=true;
  clearTimeout(depthIdleT);
  depthIdleT=setTimeout(()=>{depthActive=false;depthUpdate();},2200);
  depthUpdate();
}
function depthUpdate(){
  depthBgAdapt();
  if(!dSecs.length)return;
  const docH=document.documentElement.scrollHeight,vh=window.innerHeight,railH=dInner.clientHeight;
  const center=window.scrollY+vh*0.5;
  const pos=Math.min(railH,Math.max(0,(center/docH)*railH));
  dFill.style.height=pos+'px';dDot.style.top=pos+'px';dLabel.style.top=pos+'px';
  let active=null; dSecs.forEach(s=>{if(s.top<=center+2)active=s;});
  dLabel.textContent=(center<dSecs[0].top||!active)?'Surface':active.label;
  const awake=depthActive||dragging;
  depthEl.classList.toggle('awake',awake);
  dLabel.style.opacity=(window.scrollY>40&&awake)?'1':'0';
  dTicks.querySelectorAll('.depth-tick').forEach(t=>{const s=dSecs.find(x=>x.id===t.dataset.id);t.classList.toggle('done',!!s&&s.tickPos<=pos+0.5);});
}
window.addEventListener('scroll',depthPoke,{passive:true});
depthEl.addEventListener('pointerenter',depthPoke);
depthEl.addEventListener('pointermove',depthPoke);
window.addEventListener('resize',()=>{depthBuild();depthUpdate();});
window.addEventListener('load',()=>{depthBuild();depthUpdate();});
depthBuild();depthUpdate();

 
function depthScrollFromClientY(clientY){
  const rect=dInner.getBoundingClientRect();
  let pos=Math.max(0,Math.min(rect.height,clientY-rect.top));
  const docH=document.documentElement.scrollHeight,vh=window.innerHeight;
  const center=(pos/rect.height)*docH;
  return Math.max(0,Math.min(docH-vh,center-vh*0.5));
}
dDot.addEventListener('pointerdown',e=>{
  e.preventDefault();
  dragging=true;
  depthEl.classList.add('dragging');
  try{dDot.setPointerCapture(e.pointerId);}catch(_){}
  depthPoke();
});
document.addEventListener('pointermove',e=>{
  if(!dragging)return;
  window.scrollTo({top:depthScrollFromClientY(e.clientY),behavior:'auto'});
  depthPoke();
});
function endDrag(e){
  if(!dragging)return;
  dragging=false;
  depthEl.classList.remove('dragging');
  if(e&&e.pointerId!=null){try{dDot.releasePointerCapture(e.pointerId);}catch(_){}}
  depthPoke();
}
document.addEventListener('pointerup',endDrag);
document.addEventListener('pointercancel',endDrag);
 
(function(){
  const mqM=window.matchMedia('(max-width:1100px)'),root=document.documentElement; let hideT=null;
  window.addEventListener('scroll',function(){
    if(!mqM.matches)return;
     
    if(!root.classList.contains('solidnav')){ root.classList.remove('depth-show'); clearTimeout(hideT); return; }
    root.classList.add('depth-show');
    clearTimeout(hideT);
    hideT=setTimeout(()=>root.classList.remove('depth-show'),900);
  },{passive:true});
})();

 
(function(){
  function fill(id,items){
    const el=document.getElementById(id); if(!el)return;
    const html=items.map(function(it){
      if(it.logo)return `<span class="tk-logo"><img src="${it.logo}" alt="Certified B Corporation"></span>`;
      if(it.img)return `<span class="tk-img"><img src="${it.img}" alt="" loading="lazy"></span>`;
      return `<span class="tk-t">${it.t}</span>`;
    }).join('');
    el.innerHTML=html+html;
  }
   
  fill('ticker',[
    {t:'Grown, not made'},{img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-cd-merino.jpg')},
    {t:'Wool you can visit'},{img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-cd-lake-hawea.jpg')},
    {t:'Certified B Corporation'},{logo:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-b-corp-logo-certified-b-corporation-b-corp-logo-2022-black-rgb-svg.png')},
    {t:'Carbon negative — always'},{img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-cd-lake-hawea-wide.jpg')},
    {t:'Scan the dot, meet the flock'},{img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-chip.jpg')},
    {t:'Named farms only'},{img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-farm.jpg')},
    {t:'Knit to outlive you'},{img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-outlive.jpg')}
  ]);
   
  fill('ticker2',[
    {t:'19.5 micron · zero itch'},{img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-fleece.jpg')},
    {t:'Italian knit, Kiwi wool'},{img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-spin.jpg')},
    {t:'Fewer hands, better made'},{img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-manufacture.jpg')},
    {t:'Repair, don\'t replace'},{img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-repair.jpg')},
    {t:'No app · no account'},{img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-chip.jpg')},
    {t:'Soft. Strong. Smart.'},{img:(__RD_HOME_ASSETS_BASE__+'redesign-home-images-soft.jpg')}
  ]);
})();

 
const CD=[(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-20241211-143933000-ios.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-20241211-143944000-ios.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-20241211-144005000-ios-1.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-20241212-081318615-ios.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-74af8a8901ec4ff8afd9403b1c6c03b5-cover-large.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-dsc00745.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-dsc00799.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-dsc00804.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-dsc00954.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-dsc00957.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-dsc00959.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-dsc00966.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-dsc01127.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-dsc01373.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-dsc01386.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-ikon-150410-0354.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-ikon-150410-0861.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-img-0530.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-img-4151.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-img-4260.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-laz03960.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-laz04031.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-laz04789.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-laz05582.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-laz05630.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-laz05708.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-laz06210.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-wanaka-regions-lake-hawea-low3-1.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-zq-merino-lake-ohau-station-april-19-164.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-zq-merino-lake-ohau-station-april-19-201.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-zq-merino-lake-ohau-station-april-19-56.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-zq-merino-lake-ohau-station-april-19-77.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-dsc0085.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-dsc0091.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-ew85669-copy.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-ew85806.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-ew85861.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-ew85975.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-ew86080.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-ew86087.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-mg-2543-copy.jpg'),(__RD_HOME_ASSETS_BASE__+'redesign-home-cd-images-mg-2565.jpg')];
const dotRingEl=document.getElementById('dotRing'),dotCardEl=document.getElementById('dotCard');
function buildHomeRing(){
  if(!dotRingEl||!dotCardEl)return;
  const N=36,frag=document.createDocumentFragment();
  const w=dotCardEl.clientWidth||600,r=Math.round(w*0.40),tw=Math.round(w*0.078),th=Math.round(tw*1.25);
  for(let i=0;i<N;i++){const a=(i/N)*360;const d=document.createElement('div');d.className='dotring-thumb';d.style.setProperty('--a',a+'deg');d.style.setProperty('--r',r+'px');d.style.setProperty('--tw',tw+'px');d.style.setProperty('--th',th+'px');d.style.setProperty('--i',i);const im=document.createElement('img');im.src=CD[i%CD.length];im.alt='';im.loading='lazy';d.appendChild(im);frag.appendChild(d);}
  dotRingEl.innerHTML='';dotRingEl.appendChild(frag);
}
buildHomeRing();
if(dotRingEl){const io=new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting)dotRingEl.classList.add('in');});},{threshold:.18});io.observe(dotRingEl);}
let _rT;window.addEventListener('resize',()=>{clearTimeout(_rT);_rT=setTimeout(()=>{const was=dotRingEl&&dotRingEl.classList.contains('in');buildHomeRing();if(was)dotRingEl.classList.add('in');},200);});

 
(function(){
  const tap=document.getElementById('cdTap'),farm=document.getElementById('farm'),
        dotview=document.getElementById('cdDotview'),back=document.getElementById('cdBack'),
        stage=document.querySelector('.cd-stage');
  if(!farm||!dotview)return;
  let shown=false;
   
  function placeBack(){
    if(!tap||!back||!stage)return;
    const sr=stage.getBoundingClientRect(),tr=tap.getBoundingClientRect();
    if(tr.height===0)return;  
    back.style.top=(tr.top-sr.top+tr.height/2)+'px';
  }
   
  function land(){
    if(shown)return; shown=true;
    placeBack();
    if(stage)stage.classList.add('farm-shown');
    if(tap)tap.setAttribute('aria-expanded','true');
    dotview.classList.add('is-out');
    farm.classList.add('is-in');
    if(back)back.focus({preventScroll:true});
  }
  function unland(){
    if(!shown)return; shown=false;
    if(stage)stage.classList.remove('farm-shown');
    if(tap)tap.setAttribute('aria-expanded','false');
    farm.classList.remove('is-in');
    dotview.classList.remove('is-out');
    if(tap)tap.focus({preventScroll:true});
  }
  if(tap)tap.addEventListener('click',land);
   
  if(back)back.addEventListener('click',unland);
  window.addEventListener('load',placeBack);
  window.addEventListener('resize',()=>{if(!shown)placeBack();});
  placeBack();
})();

 
(function(){
  const grid=document.getElementById('guideGrid'); if(!grid)return;
  const panels=[...grid.querySelectorAll('.gch')]; if(!panels.length)return;
  function set(n){ panels.forEach((p,j)=>{ const on=j===n; p.classList.toggle('active',on); p.classList.toggle('m-open',on); }); }
  panels.forEach((p,j)=>{ p.addEventListener('mouseenter',()=>set(j)); p.addEventListener('focus',()=>set(j)); p.addEventListener('click',()=>set(j)); });
  set(0);
})();

 
(function(){
  const chips=[...document.querySelectorAll('.position .fchip')]; if(!chips.length)return;
  const pop=document.createElement('div');
  pop.className='fpop'; pop.setAttribute('role','dialog'); pop.setAttribute('aria-modal','true'); pop.setAttribute('aria-hidden','true');
  pop.innerHTML='<div class="fpop-scrim" data-close></div><div class="fpop-card"><button class="fpop-close" type="button" data-close aria-label="Close">×</button><img alt=""><div class="fpop-body"><h4></h4><p></p></div></div>';
  (document.querySelector('.rd-home')||document.body).appendChild(pop);
  const pImg=pop.querySelector('img'),pH=pop.querySelector('h4'),pP=pop.querySelector('p');
  let lastFocus=null;
  function open(chip){
    const img=chip.querySelector('img');
    pImg.src=img?img.src:''; pImg.alt=chip.dataset.title||'';
    pH.textContent=chip.dataset.title||'';
    pP.innerHTML=chip.dataset.cap||'';
    lastFocus=chip; pop.classList.add('open'); pop.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    pop.querySelector('.fpop-close').focus({preventScroll:true});
  }
  function close(){
    pop.classList.remove('open'); pop.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
    if(lastFocus&&lastFocus.focus)lastFocus.focus({preventScroll:true});
  }
  chips.forEach(c=>c.addEventListener('click',e=>{e.preventDefault();open(c);}));
  pop.addEventListener('click',e=>{if(e.target.closest('[data-close]'))close();});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&pop.classList.contains('open'))close();});
})();

 
(function(){
  const grid=document.querySelector('.press-grid'),dotsWrap=document.getElementById('pressDots');
  if(!grid||!dotsWrap)return;
  const quotes=[...grid.querySelectorAll('.quote')]; if(quotes.length<2)return;
  const mq=window.matchMedia('(min-width:680px)');
  const reduce=window.matchMedia('(prefers-reduced-motion:reduce)');
  const GRID_MS=6500, SWIPE_MS=4500;       
  let mode=null, io=null, timer=null, advance=null, delay=0, onResize=null;
  function stop(){ if(timer){clearInterval(timer);timer=null;} }
  function start(){ stop(); if(reduce.matches||!advance)return; timer=setInterval(()=>{ if(!document.hidden)advance(); },delay); }
  function bump(){ start(); }  
  function teardown(){ stop(); advance=null; if(io){io.disconnect();io=null;} if(onResize){window.removeEventListener('resize',onResize);onResize=null;} quotes.forEach(q=>q.style.display=''); grid.style.minHeight=''; dotsWrap.innerHTML=''; }
  function buildGrid(){  
    const per=6, pages=Math.ceil(quotes.length/per); let cur=0;
    for(let p=0;p<pages;p++){const b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Reviews — screen '+(p+1)+' of '+pages);b.addEventListener('click',()=>{go(p);bump();});dotsWrap.appendChild(b);}
    function paint(){ quotes.forEach((q,j)=>{q.style.display=(Math.floor(j/per)===cur)?'':'none';}); [...dotsWrap.children].forEach((d,p)=>d.setAttribute('aria-current',p===cur?'true':'false')); }
    function go(p){ const nxt=(p%pages+pages)%pages; if(nxt===cur)return; cur=nxt;
      if(reduce.matches){paint();return;}
      grid.classList.add('is-fading');
      setTimeout(()=>{ paint(); requestAnimationFrame(()=>grid.classList.remove('is-fading')); },700); }
    paint();
     
    function lockHeight(){ if(grid.classList.contains('is-fading'))return; const prev=cur; grid.style.minHeight=''; const h0=Math.max(...Array.from({length:pages},(_,p)=>{cur=p;paint();return grid.offsetHeight;})); cur=prev; paint(); grid.style.minHeight=h0+'px'; }
    lockHeight();
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(lockHeight);
    let rz; onResize=()=>{clearTimeout(rz);rz=setTimeout(lockHeight,200);}; window.addEventListener('resize',onResize);
    advance=()=>go(cur+1); delay=GRID_MS;
  }
  function buildSwipe(){  
    let cur=0;
    quotes.forEach((q,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Review '+(i+1)+' of '+quotes.length);b.addEventListener('click',()=>{goTo(i);bump();});dotsWrap.appendChild(b);});
    const dotBtns=[...dotsWrap.children];
    function setActive(i){ cur=i; dotBtns.forEach((d,k)=>d.setAttribute('aria-current',k===i?'true':'false')); }
    function goTo(i){ grid.scrollTo({left:i*grid.clientWidth,behavior:'smooth'}); }  
    setActive(0);
    io=new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting&&e.intersectionRatio>0.6){setActive(quotes.indexOf(e.target));}});},{root:grid,threshold:[0.6]});
    quotes.forEach(q=>io.observe(q));
     
    grid.addEventListener('pointerdown',bump,{passive:true});
    grid.addEventListener('scroll',()=>{clearTimeout(grid.__st);grid.__st=setTimeout(bump,600);},{passive:true});
    advance=()=>goTo((cur+1)%quotes.length); delay=SWIPE_MS;
  }
  function apply(){ const want=mq.matches?'grid':'swipe'; if(want===mode)return; mode=want; teardown(); if(mode==='grid')buildGrid(); else buildSwipe(); start(); }
  apply();
  if(mq.addEventListener)mq.addEventListener('change',apply); else mq.addListener(apply);
  if(reduce.addEventListener)reduce.addEventListener('change',start);
  document.addEventListener('visibilitychange',()=>{ if(document.hidden)stop(); else start(); });
})();

 
window.__gender=(function(){
  let g='women'; try{var s=localStorage.getItem('si-gender'); if(s==='men'||s==='women')g=s;}catch(e){}
  const subs=[];
  function set(v){ g=/^m/i.test(v)?'men':'women'; try{localStorage.setItem('si-gender',g);}catch(e){} subs.forEach(fn=>{try{fn(g);}catch(e){}}); }
  return { get:function(){return g;}, set:set, sub:function(fn){subs.push(fn);try{fn(g);}catch(e){}} };
})();
 
(function(){
  const shop=document.getElementById('shop');
  const allBtns=[...document.querySelectorAll('.shop-seg button[data-g]')];
  allBtns.forEach(b=>b.addEventListener('click',()=>window.__gender.set(b.dataset.g)));
  window.__gender.sub(function(g){ allBtns.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.g===g))); if(shop)shop.setAttribute('data-gender',g); });
   
  (function(){ const tiles=[...document.querySelectorAll('#shop .style-tile')].filter(t=>t.querySelector('img[data-women]')); if(!tiles.length)return;
    window.__gender.sub(function(g){ tiles.forEach(tile=>{
      const name=tile.querySelector('.st-name'), img=tile.querySelector('img[data-women]');
      const href=(g==='men'?tile.dataset.menHref:tile.dataset.womenHref); if(href)tile.setAttribute('href',href);
      if(name&&name.dataset.womenLabel){ const lbl=g==='men'?name.dataset.menLabel:name.dataset.womenLabel; if(lbl){ name.textContent=lbl; if(img)img.alt=lbl; } }
      if(img){ const next=(g==='men'?img.dataset.men:img.dataset.women); if(next&&img.getAttribute('src')!==next){ const pre=new Image(); pre.onload=function(){ img.style.opacity='0'; setTimeout(function(){ img.src=next; img.style.opacity=''; },200); }; pre.src=next; } }
    }); });
  })();
  document.querySelectorAll('.hero-cta').forEach(a=>a.addEventListener('click',()=>window.__gender.set(/women/i.test(a.textContent)?'women':'men')));
})();

 
(function(){
  const items=[...document.querySelectorAll('.deeper')]; if(!items.length)return;
   
  function place(el){ const note=el.querySelector('.deeper-note'); if(!note)return; note.style.setProperty('--dx','0px'); const r=note.getBoundingClientRect(),m=10; let dx=0; if(r.left<m)dx=m-r.left; else if(r.right>window.innerWidth-m)dx=(window.innerWidth-m)-r.right; if(dx)note.style.setProperty('--dx',Math.round(dx)+'px'); }
  function closeAll(except){ items.forEach(el=>{ if(el!==except){el.classList.remove('is-open');el.setAttribute('aria-expanded','false');} }); }
  items.forEach(el=>{
    el.setAttribute('tabindex','0'); el.setAttribute('role','button'); el.setAttribute('aria-expanded','false');
    el.addEventListener('click',e=>{ e.preventDefault(); e.stopPropagation(); const open=el.classList.contains('is-open'); closeAll(el); if(!open){place(el);el.classList.add('is-open');el.setAttribute('aria-expanded','true');} else {el.classList.remove('is-open');el.setAttribute('aria-expanded','false');} });
    el.addEventListener('mouseenter',()=>place(el));
    el.addEventListener('focus',()=>place(el));
    el.addEventListener('keydown',e=>{ if(e.key==='Enter'||e.key===' '){e.preventDefault();el.click();} else if(e.key==='Escape'){el.classList.remove('is-open');el.setAttribute('aria-expanded','false');el.blur();} });
  });
  document.addEventListener('click',()=>closeAll(null));
})();

 
(function(){
  const items=[...document.querySelectorAll('[data-parallax]')]; if(!items.length)return;
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const RANGE=70; let ticking=false;
  function frame(){ ticking=false; const vh=window.innerHeight;
    items.forEach(el=>{ const sec=el.closest('section')||el.parentElement; const r=sec.getBoundingClientRect();
      if(r.bottom<0||r.top>vh)return; const prog=(r.top+r.height/2-vh/2)/(vh+r.height);  
      el.style.transform='translate3d(0,'+(-prog*RANGE).toFixed(1)+'px,0)'; }); }
  function onScroll(){ if(!ticking){ticking=true;requestAnimationFrame(frame);} }
  window.addEventListener('scroll',onScroll,{passive:true}); window.addEventListener('resize',onScroll); frame();
})();

 
const stickerIO=new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');stickerIO.unobserve(e.target);}});},{threshold:.4});
document.querySelectorAll('.hsticker').forEach(s=>stickerIO.observe(s));
 
const kinIO=new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');kinIO.unobserve(e.target);}});},{threshold:.18});
document.querySelectorAll('.disp-grid .kin').forEach(el=>kinIO.observe(el));



(function(){
const COLOURS=[
    ['Poppy Red','#E8331F','A flare of heat at the top of the day','red'],
    ['Tomato Red','#CF3B26','Vine-ripened, the last of the summer sun','red'],
    ['Konini Burgundy','#8E2742','The last red light before the ridge','red'],
    ['Candyfloss Pink','#F2A8C2','First blush of an alpine dawn','pink'],
    ['Burnt Orange','#BF531D','Rust on the high-country tussock','orange'],
    ['Persimmon Orange','#F2641E','The warmest hour of the day','orange'],
    ['Sunflower Yellow','#F2B705','Late-summer fields in full tilt','yellow'],
    ['Moss Green','#6FA63C','Light going long across the hills','green'],
    ['Forest Green','#2E6B3A','Deep in the cool of the bush','green'],
    ['Emerald Green','#1E8C4E','New growth after the rain','green'],
    ['Bottle Green','#0C5A3D','The shaded heart of the canopy','green'],
    ['Aqua Green','#12C2A2','Clean sun on the shallows','green'],
    ['Turquoise Blue','#19B0BE','Glacial melt in the river bend','blue'],
    ['Mineral Sea','#2F8AA0','Still water over greenstone','blue'],
    ['Cloud Blue','#A6CBE3','A pale sky, morning haze lifting','blue'],
    ['Tasman Blue','#22506E','The morning finding its colour','blue'],
    ['Baltic Blue','#2E6FA6','Cold open water, far from shore','blue'],
    ['Atlantic Blue','#1C5C8C','The deep mid-ocean','blue'],
    ['Pacific Blue','#1b2950','The lake at dusk, deep and still','blue'],
    ['Cobalt Blue','#2340B8','Lake Wakatipu, first light','blue'],
    ['Royal Purple','#5E2E9E','The last colour left in the sky','purple'],
    ['Lupin Lilac','#9A87F5','Lakeside lupins, midsummer','purple'],
    ['Lavender Haze','#C9B8E8','Dusk settling over the valley','purple'],
    ['Fawn Brown','#B68C5E','Dry grass on the river flats','brown'],
    ['Deep Earth','#5A4632','The land going to ground after dark','brown'],
    ['Almond White','#EFE7D6','The first grey-gold light','white'],
    ['Raw White','#F5F2EA','Undyed — straight off the flock','white'],
    ['Cloud Ash','#CACDC9','Woodsmoke over the water','white'],
    ['Moon Grey','#A7ABAE','Quiet light, everything held still','white'],
    ['Slate Grey','#5C6468','Wet stone on the riverbed','black'],
    ['Anthracite Black','#2B2B2E','The quietest colour we make','black']
  ];

const csSpectrum=document.getElementById('csSpectrum'), csCaption=document.getElementById('csCaption');
  if(csSpectrum){
    const isLight=hex=>{const c=hex.replace('#','');const r=parseInt(c.slice(0,2),16),g=parseInt(c.slice(2,4),16),b=parseInt(c.slice(4,6),16);return (0.2126*r+0.7152*g+0.0722*b)>168;};
     
    const CS_KEY=new Set(['Poppy Red','Persimmon Orange','Sunflower Yellow','Moss Green','Aqua Green','Pacific Blue','Royal Purple','Slate Grey']);
    csSpectrum.innerHTML=COLOURS.map(([n,h,story,fam])=>`<button class="cs-seg${isLight(h)?' on-light':''}${CS_KEY.has(n)?' cs-key':''}" style="background:${h}" data-name="${n}" data-story="${story||''}" data-family="${fam||''}" title="${n}" aria-label="${n} — ${story||''}"><span class="cs-seg-name">${n}</span></button>`).join('');
    const csSegs=[...csSpectrum.querySelectorAll('.cs-seg')];
    const csCapName=document.getElementById('csCapName'), csCapStory=document.getElementById('csCapStory'), csCapShop=document.getElementById('csCapShop');
     
    const FAM_LABEL={blue:'Blues',green:'Greens',red:'Reds',orange:'Oranges',yellow:'Yellows',pink:'Pinks',purple:'Purples',white:'Whites',brown:'Browns',black:'Blacks'};
    const famURL=fam=>'/collections/womens-all/'+fam;
    const canHover=window.matchMedia&&window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    function csActivate(seg){ csSegs.forEach(s=>s.classList.toggle('active',s===seg)); if(csCapName)csCapName.textContent=seg.dataset.name; if(csCapStory)csCapStory.textContent=seg.dataset.story; const fam=seg.dataset.family; if(csCapShop&&fam){ csCapShop.href=famURL(fam); csCapShop.textContent='Shop '+(FAM_LABEL[fam]||fam)+' →'; csCapShop.style.display=''; } if(csCaption)csCaption.classList.add('show'); }
    csSegs.forEach(seg=>{
      seg.addEventListener('mouseenter',()=>csActivate(seg));
      seg.addEventListener('focus',()=>csActivate(seg));
       
      seg.addEventListener('click',e=>{ e.preventDefault(); const fam=seg.dataset.family; if(canHover&&fam){ window.location.href=famURL(fam); } else { csActivate(seg); } });
    });
    if(csSegs[0]) csActivate(csSegs[0]);  
  }
})();


 
(function(){
  var root=document.documentElement, hd=document.getElementById('siteHeader'), body=document.body, hero=document.querySelector('.hero'), ann=document.querySelector('.announce');
  function measure(){ if(hd) root.style.setProperty('--topbar-h', hd.offsetHeight+'px'); if(ann) root.style.setProperty('--announce-h', ann.offsetHeight+'px'); }
  measure(); window.addEventListener('resize', measure); window.addEventListener('load', measure);
  var last=window.pageYOffset||0, ticking=false;
  function locked(){ return body.classList.contains('menu-open')||body.classList.contains('nav-open')||body.classList.contains('search-open'); }
  function update(){
    ticking=false;
    var y=window.pageYOffset||document.documentElement.scrollTop;
    var solidAt=(hero?hero.offsetHeight:600)-(hd?hd.offsetHeight:58);
    root.classList.toggle('solidnav', y>solidAt);
    if(locked()||y<10){ root.classList.remove('nav-up'); last=y; return; }
    if(y>last+6) root.classList.add('nav-up');
    else if(y<last-6) root.classList.remove('nav-up');
    last=y;
  }
  window.addEventListener('scroll', function(){ if(!ticking){ requestAnimationFrame(update); ticking=true; } }, {passive:true});
})();


/* lazy-load <video data-src> elements once they're near the viewport */
(function(){
  var vids=[].slice.call(document.querySelectorAll('video[data-src]'));
  if(!vids.length) return;
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(!entry.isIntersecting) return;
      var v=entry.target;
      io.unobserve(v);
      v.src=v.dataset.src;
      v.removeAttribute('data-src');
      v.load();
      if(v.dataset.autoplay) v.play().catch(function(){});
    });
  },{rootMargin:'200px 0px'});
  vids.forEach(function(v){ io.observe(v); });
})();
})();
